import Vue from 'vue';
import Vuetify from 'vuetify'; // import Vuetify from "vuetify/lib"
import 'vuetify/dist/vuetify.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader

Vue.use(Vuetify);

// Kairos Afrika brand palettes — keep in sync with src/assets/css/_tokens.scss
// (source of truth: kairosafrika.com redesign / kairos-vas-console globals.css)
export default new Vuetify({
  theme: {
    options: { customProperties: true },
    dark: false, // real value applied at boot by src/utils/theme.ts
    themes: {
      light: {
        primary: '#FF0055',
        secondary: '#14181C',
        accent: '#14181C',
        success: '#047857',
        warning: '#CF8A09',
        error: '#D2483A',
        info: '#2F6DF0',
        anchor: '#FF0055',
      },
      dark: {
        primary: '#FF3D78',
        secondary: '#9AA3AE',
        accent: '#9AA3AE',
        success: '#34D399',
        warning: '#E0A52B',
        error: '#E5675A',
        info: '#5B8BF5',
        anchor: '#FF3D78',
      },
    },
  },
  icons: {
    iconfont: 'md',
  },
});
